import { environment } from 'src/environments/environment';
import { Footer } from './../../../store/global/global.state';
import { ShareService } from './../../../services/utility/sharer.service';
import { Component, Input, OnInit } from '@angular/core';
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GlobalActions } from 'src/app/store/global/global.actions';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  window: any;
  @Input()
  whatsapp!: string;
  @Select((state: any) => state.global.footer) footer$!: Observable<Footer>;
  
  faInstagram = faInstagram;
  faWhatsapp = faWhatsapp;
  faFacebook = faFacebook;
  faYoutube = faYoutube;
  faTwitter = faTwitter;
  version = environment.version;
  constructor(
    private store: Store,
    private shareService: ShareService) {}

  ngOnInit(): void {}
  openMap() {
    this.store.dispatch(new GlobalActions.OpenMap());
  }

  goWhatsapp(whatsapp: string) {
    this.shareService.shareWhatsapp(whatsapp);
  }
}
